import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePutApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { CheckSample, CheckSampleForm, CheckSampleSearchForm } from 'entities/check_sample'

type CheckSamplesResponse = PagingResponse & {
    results: CheckSample[]
}

export function useFetchCheckSamplesApi(searchForm: Form<CheckSampleSearchForm>): IndexApiSet<CheckSamplesResponse> & { execute: () => void } {
    const apiPath = 'check_samples/'
    const api = useIndexApi<CheckSamplesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

type CheckSampleResponse = BaseResponse & CheckSample

export function useFetchCheckSampleApi(): ApiSet<CheckSampleResponse> & { execute: (id: number) => void } {
    const api = useShowApi<CheckSampleResponse>(new CraifHttpClient(), {
        initialResponse: {} as CheckSampleResponse,
    })

    const execute = (id: number): void => {
        const apiPath = `check_samples/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export function usePutCheckSampleApi(): ApiSet<BaseResponse> & { execute: (form: Form<CheckSampleForm>) => void } {
    const apiSet = usePutApi<BaseResponse, CheckSampleForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<CheckSampleForm>) => {
        const apiPath = `check_samples/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutCheckSamplesApi(): ApiSet<BaseResponse> & { execute: (form: Form<CheckSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, CheckSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<CheckSampleForm[]>) => {
        const apiPath = `check_samples/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
export function usePutCheckSampleResultStatusApi(): ApiSet<BaseResponse> & { execute: (form: Form<CheckSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, CheckSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<CheckSampleForm[]>) => {
        const apiPath = `check_samples/update_result_status/`
        
        // NOTE: resultCheckedUserがNoneになり、更新エラーになるケースを防ぐため
        // resultCheckedUserIdを渡すだけでユーザのひもづけができるのでresultCheckedUserは不要
        form.object.forEach((sample) => {
            delete sample.resultCheckedUser
        })

        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function usePutCheckSampleResultConfirmApi(): ApiSet<BaseResponse> & { execute: (form: Form<CheckSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, CheckSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<CheckSampleForm[]>) => {
        const apiPath = `check_samples/update_result_confirm/`
        
        form.object.forEach((sample) => {
            delete sample.resultCheckedUser
        })

        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}